import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { commonService } from "Dashboard/services/common.service";
import { IStringOption } from "Dashboard/domain/IStringOption";

const UnitSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IStringOption[]>([]);
  const [value, setValue] = useState<IStringOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const units = await commonService.getUnits({});
      const op = units.map((unit) => {
        return {
          label: unit.name,
          value: unit.unitId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else setValue(undefined);
  }, [options, props.value]);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable={props.isClearable !== false}
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      isDisabled={props.isDisabled === true}
      {...{ error: props.error }}
    />
  );
});

export default UnitSelect;
